import React from "react";
import { useTranslation } from "react-i18next";

import {
  formatPassFailValue,
  getQualityStatusPillClasses,
} from "../../utils/results/resultQuality";

export default function QualityStatusDisplay({
  status,
  fallback = "--",
  qualityStatusPillsEnabled = false,
}) {
  const { t } = useTranslation();

  if (!status) {
    return <>{fallback}</>;
  }

  const label = formatPassFailValue(status, t, fallback, {
    qualityStatusPillsEnabled,
  });

  if (!qualityStatusPillsEnabled) {
    return <>{label}</>;
  }

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={[
        "inline-flex h-3 w-8 shrink-0 rounded-full align-middle",
        getQualityStatusPillClasses(status),
      ].join(" ")}
    />
  );
}
